import { memo } from 'react'
import { countries } from '../../assets/countryList'
import { FORM_LABEL_CLASS } from '../../lib/formStyles'
import SearchableSelect from './Forms/SearchableSelect'

type OrganisationJurisdictionSelectProps = {
	value: string | undefined
	onChange: (value: string | undefined) => void
	label?: string
	isClearable?: boolean
	name?: string
	/** Stretch the control to the full width of its container, matching sibling full-width form fields (see SearchableSelect's `fillContainer`). */
	fillContainer?: boolean
	isDisabled?: boolean
	styles?: Record<string, (base: any, state: any) => any>
}

/**
 * Shared alpha-2 jurisdiction dropdown (Sub-task I) - storage-consistent with `companies`/
 * `suppliers`/`user_training_sessions.jurisdiction_code`, unlike the alpha-3-keyed `JurisdictionSelect`
 * (SECR report filtering only). See docs/design/data-model.md "Jurisdiction code format".
 */
function OrganisationJurisdictionSelect({
	value,
	onChange,
	label = 'Organisation jurisdiction',
	isClearable = true,
	name = 'jurisdictionCode',
	fillContainer = false,
	isDisabled = false,
	styles,
}: OrganisationJurisdictionSelectProps) {
	return (
		<label className="block mt-8">
			<span className={FORM_LABEL_CLASS}>{label}</span>
			<br />
			<SearchableSelect
				name={name}
				options={countries}
				isMulti={false}
				isSearchable={true}
				isClearable={isClearable}
				isDisabled={isDisabled}
				styles={styles}
				fillContainer={fillContainer}
				className="w-full mt-1"
				onChange={(option) => onChange(option?.value)}
				value={countries.filter((option) => option.value === value)}
			/>
		</label>
	)
}

// Memoised: the country list is large, so re-rendering on every keystroke in a sibling field is slow.
export default memo(OrganisationJurisdictionSelect)
